module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCnIt.dccf95f.ttf";